<template>
  <div id="footer">
    <div class="footWrap">
      <!-- <div class="footHead">
        <div></div>
        <div>
          <div class="footText">购物指南</div>
          <div class='textHover'>联系客服</div>
        </div>
        <div>
          <div class="footText">配送方式</div>
          <div class='textHover'>上门自提</div>
          <div class='textHover'>配送费收取标准</div>
        </div>
        <div>
          <div class="footText">支付方式</div>
          <div class='textHover'>货到付款</div>
          <div class='textHover'>在线支付</div>
          <div class='textHover'>公司转账</div>
        </div>
        <div>
          <div class="footText">售后服务</div>
          <div class='textHover'>售后政策</div>
          <div class='textHover'>退款说明</div>
          <div class='textHover'>取消订单</div>
        </div>
        <div></div>
      </div> -->
      <div class="footContent">
        <div class="footMenu">
          <!-- <div class="footText textHover" >关于我们</div>
          <span>|</span>
          <div class="footText textHover" >联系我们</div>
          <span>|</span>
          <div class="footText textHover" >联系客服</div>
          <span>|</span>
          <div class="footText textHover" >合作招商</div>
          <span>|</span>
          <div class="footText textHover" >商家帮助</div>
          <span>|</span>
          <div class="footText textHover" >营销中心</div>
          <span>|</span>
          <div class="footText textHover" >手机肉联所</div>
          <span>|</span>
          <div class="footText textHover" >友情链接</div>
          <span>|</span>
          <div class="footText textHover" >隐私政策</div> -->
          <div @click="toServerce" class="footText textHover">
            白条售后服务规范
          </div>
          <span>|</span>
          <div @click="toIssue" class="footText textHover">
            交易平台纠纷处理
          </div>
        </div>

        <!-- <div style="width:1000px;margin:0 auto;text-align:center; padding:20px 0;display:flex;flex-direction:row;justifycontent:center;">
          <div  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="@/assets/records.png" style="float:left;margin-left:50px"/>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011502004008" style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11011502004008号</a >
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011502004008" style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京asdf 11011502004008号</a >
            <br/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京ICP备19038600号-1 消费者维权热线：4006600051</p >
            <div>&copy;&nbsp;北京中农亿家资源科技有限公司 版权所有</div>
            <div>北京市大兴区兴政街31号(科技大厦)8层31-7-804 </div>
          </div>
        </div> -->

        <div
          v-if="isBeijing"
          style="
            width: 1000px;
            margin: 0 auto;
            text-align: center;
            display: flex;
            flex-direction: culumn;
            justify-content: center;
          "
        >
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <!-- <img src="@/assets/records.png" /> -->
            <a
              target="_blank"
              href="http://beian.gov.cn/portal/registerSystemInfo?recordcode=11011502004008"
              style="
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #939393;
              "
              >京公网安备 11011502004008号</a
            >
            <a
              target="_blank"
              href="http://beian.miit.gov.cn/"
              style="
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #939393;
              "
              >| 京ICP备19038600号-1</a
            >
            <a
              target="_blank"
              href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=京B2-20200600&type=xuke"
              style="
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #939393;
              "
              >| 电信增值业务许可证编号：京B2-20200600</a
            >
            <a
              target="_blank"
              href="https://www.chinausmeat.com/licence/foodLicence.jpg"
              style="
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #939393;
              "
              >| 网络食品经营许可备案</a
            >
          </div>
        </div>
        <div
          v-else
          style="
            width: 1000px;
            margin: 0 auto;
            text-align: center;
            display: flex;
            flex-direction: culumn;
            justify-content: center;
          "
        >
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <!-- <img src="@/assets/records.png" /> -->
            <a
              target="_blank"
              href="http://beian.miit.gov.cn/"
              style="
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #939393;
              "
              >湘ICP备20011940号-1</a
            >
          </div>
        </div>
        <p
          v-if="!isBeijing"
          style="
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            color: #939393;
            font-size: 12px;
          "
        >
          客服电话及时间：0734-3170558 |
          周一至周五上午09:00-12:00,下午1:30-18:00
        </p>
        <p
          style="
            height: 20px;
            line-height: 20px;
            margin: 0px 0px 0px 5px;
            color: #939393;
            font-size: 12px;
          "
        >
          消费者维权热线：4006600051
        </p>

        <div>
          &copy;&nbsp;{{
            isBeijing
              ? "北京中农亿家资源科技有限公司"
              : "湖南省中农亿家资源科技有限公司"
          }}
          版权所有
        </div>
        <div>
          {{
            isBeijing
              ? "北京市大兴区兴政街31号(科技大厦)8层31-7-804"
              : "衡阳市高新区芙蓉路58号愉景南苑11栋写字楼"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isBeijing } from "@/api/api";
export default {
  data() {
    return {
      isBeijing: isBeijing,
    };
  },
  methods: {
    toServerce() {
      this.$router.push({ name: "serviceAgreement" });
    },
    toIssue() {
      this.$router.push({ name: "issueAgreement" });
    },
  },
};
</script>

<style lang='less' scoped>
.footWrap {
  width: "100%";
  height: 140px;
  border-top: 1px solid #ccc;
  background-color: #f6f6f6;
  margin-top: 50px;
  .footHead {
    width: "100%";
    height: 100px;
    margin: 0 auto;
    display: flex;
    margin-top: 20px;
    justify-content: space-around;
    div {
      width: 100px;
      display: flex;
      margin-top: 5px;
      flex-direction: column;
      align-items: flex-start;
      color: #a19c9c;
      font-size: 13px;
      .footText {
        color: #1a1a2b;
        font-size: 15px;
      }
    }
  }
  .footContent {
    width: 100%;
    border-top: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      color: #b8bfbf;
      font-size: 9px;
    }
    .footMenu {
      display: flex;
      flex-direction: center;
      margin: 14px 0;
      span {
        font-size: 10px;
        color: #b6bcc4;
        margin: 0 10px;
      }
      div {
        font-size: 10px;
        color: #71767d;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/components/Footer/FooterComponent.vue